import { application } from "globals/endpoints";

const BASE = "../v3/pbx/entitymedia";

const entityMediaApi = {
  async upload(file, entityType, fieldName) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("entityType", entityType);
    if (fieldName) formData.append("fieldName", fieldName);
    return (
      await application.post(`${BASE}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).data;
  },

  async fetchAudioBlob(filePath) {
    return (
      await application.post(
        `${BASE}/play`,
        { filePath },
        { responseType: "blob" }
      )
    ).data;
  },

  async remove(filePath) {
    return (await application.post(`${BASE}/delete`, { filePath })).data;
  },

  async list(entityType) {
    return (await application.post(`${BASE}/list`, { entityType })).data;
  },

  async getMediaCenterFiles() {
    return (await application.get("/ivr/get/mediaCenterJson")).data;
  },
};

export default entityMediaApi;
